import validator from 'react-validation';

import { isURL as validadatorIsURL } from 'validator';

export const isURL = (value) => (
  validadatorIsURL(value)
);

// Hardcoded clause to hide farfetch related fields
// In December 2020 a new retailer has come on board, until a proper strategy is implemented
// We have to live with this hack
export const isFarFetchUser = () => {
  const userId = parseInt(sessionStorage.getItem('userID')) || null;
  return (userId !== 15);
};



// WEBPACK FOOTER //
// ./src/lib/util.js